import { makeStyles } from '@rbx/ui';

const useParameterTableStyles = makeStyles()(() => ({
  title: {
    marginBottom: 24,
  },
}));

export default useParameterTableStyles;
